export default {
    params: ['max'],
    validate: (value, { max }) => {
        if (max && Number(value) > Number(max)) {
            return `The {_field_} field must be $${Number(max).toLocaleString('en-US')} or less`;
        }
        return true;
    }
};